import d from "../utils.js";
import U from "../helpers/buildURL.js";
import q from "./InterceptorManager.js";
import R from "./dispatchRequest.js";
import w from "./mergeConfig.js";
import A from "./buildFullPath.js";
import m from "../helpers/validator.js";
import T from "./AxiosHeaders.js";
const i = m.validators;
class k {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new q(),
      response: new q()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, e) {
    try {
      return await this._request(t, e);
    } catch (r) {
      if (r instanceof Error) {
        let l = {};
        Error.captureStackTrace ? Error.captureStackTrace(l) : l = new Error();
        const s = l.stack ? l.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? s && !String(r.stack).endsWith(s.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + s) : r.stack = s;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, e) {
    typeof t == "string" ? (e = e || {}, e.url = t) : e = t || {}, e = w(this.defaults, e);
    const { transitional: r, paramsSerializer: l, headers: s } = e;
    r !== void 0 && m.assertOptions(r, {
      silentJSONParsing: i.transitional(i.boolean),
      forcedJSONParsing: i.transitional(i.boolean),
      clarifyTimeoutError: i.transitional(i.boolean)
    }, !1), l != null && (d.isFunction(l) ? e.paramsSerializer = {
      serialize: l
    } : m.assertOptions(l, {
      encode: i.function,
      serialize: i.function
    }, !0)), e.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? e.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : e.allowAbsoluteUrls = !0), m.assertOptions(e, {
      baseUrl: i.spelling("baseURL"),
      withXsrfToken: i.spelling("withXSRFToken")
    }, !0), e.method = (e.method || this.defaults.method || "get").toLowerCase();
    let f = s && d.merge(
      s.common,
      s[e.method]
    );
    s && d.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (a) => {
        delete s[a];
      }
    ), e.headers = T.concat(f, s);
    const h = [];
    let b = !0;
    this.interceptors.request.forEach(function(n) {
      typeof n.runWhen == "function" && n.runWhen(e) === !1 || (b = b && n.synchronous, h.unshift(n.fulfilled, n.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(n) {
      c.push(n.fulfilled, n.rejected);
    });
    let u, o = 0, p;
    if (!b) {
      const a = [R.bind(this), void 0];
      for (a.unshift(...h), a.push(...c), p = a.length, u = Promise.resolve(e); o < p; )
        u = u.then(a[o++], a[o++]);
      return u;
    }
    p = h.length;
    let y = e;
    for (o = 0; o < p; ) {
      const a = h[o++], n = h[o++];
      try {
        y = a(y);
      } catch (S) {
        n.call(this, S);
        break;
      }
    }
    try {
      u = R.call(this, y);
    } catch (a) {
      return Promise.reject(a);
    }
    for (o = 0, p = c.length; o < p; )
      u = u.then(c[o++], c[o++]);
    return u;
  }
  getUri(t) {
    t = w(this.defaults, t);
    const e = A(t.baseURL, t.url, t.allowAbsoluteUrls);
    return U(e, t.params, t.paramsSerializer);
  }
}
d.forEach(["delete", "get", "head", "options"], function(t) {
  k.prototype[t] = function(e, r) {
    return this.request(w(r || {}, {
      method: t,
      url: e,
      data: (r || {}).data
    }));
  };
});
d.forEach(["post", "put", "patch"], function(t) {
  function e(r) {
    return function(s, f, h) {
      return this.request(w(h || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: s,
        data: f
      }));
    };
  }
  k.prototype[t] = e(), k.prototype[t + "Form"] = e(!0);
});
export {
  k as default
};
